import { useState } from 'react';
import {
    Button,
    DatePicker,
    Divider,
    Form,
    Input,
    Modal,
    Select,
    Switch,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import UserService from '../../../../../services/UserService';
import DataFlowService from '../../../../../services/DataFlow.service';
import useNotify from '../../../../../context/Notification/useNotify';

import { ROUTER } from '../../../../../constants/router';
import { ConvertDate } from './utils';
import { useAuthContext } from '../../../../../context/auth-context';

const ModalReviewed = ({
    open,
    handelClose,
    getInventoryDataFlowInfo,
    status,
    oraganize,
    dataFlowInfo,
}) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const notify = useNotify();
    let { businessProcessId } = useParams();
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState();

    const isSecondReviewRequire = Form.useWatch('isSecondReviewRequire', form);

    let navigate = useNavigate();

    const id = UserService.getUi();

    const { username } = useAuthContext();

    let isReviewBy2 = false;
    if (dataFlowInfo?.reviewDate && dataFlowInfo?.reviewDate2) {
        isReviewBy2 = false;
    } else if (dataFlowInfo?.reviewById2 === id) {
        isReviewBy2 = true;
    }

    const onFinish = async (values) => {
        const payload = {
            businessProcessId,
            status,
            lastReviewDate: values.lastReviewDate.toISOString(),
            nextReviewDue: values.nextReviewDue
                ? values.nextReviewDue.toISOString()
                : '',
            reason: '',
            isSecondReviewRequire: values?.isSecondReviewRequire,
            reviewBy2: isReviewBy2 ? id : values?.reviewBy2,
            comment: values.comment,
        };
        setLoading(true);
        try {
            const { data } = await DataFlowService.changeStatusDataFlow(
                payload
            );
            if (data.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully save data'),
                });
                getInventoryDataFlowInfo();
                setLoading(false);
                handelClose();
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view`
                );
            } else {
                setLoading(false);
                handelClose();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
            form.resetFields();
        } catch (error) {
            console.log(error);
            setLoading(false);
            handelClose();
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    const disabledDateStart = (current) => {
        return current && current > endDate;
    };

    const disabledDate = (current) => {
        return current && current < startDate;
    };

    const reviewBy = dataFlowInfo?.reviewBy;
    const reviewBy2 = dataFlowInfo?.reviewBy2;
    const nextReviewDue = dataFlowInfo?.nextReviewDue
        ? new Date(dataFlowInfo?.nextReviewDue).toISOString()
        : moment().toISOString();
    const review = oraganize?.find(
        (oraganize) => username === oraganize?.fullName
    );

    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                onFinish={onFinish}
                layout="vertical"
                initialValues={{
                    reviewBy: id,
                    lastReviewDate: moment(),
                    nextReviewDue: isReviewBy2 ? moment(nextReviewDue) : '',
                    reviewBy2: isSecondReviewRequire
                        ? dataFlowInfo?.reviewBy2
                        : null,
                    comment: '',
                }}
            >
                <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                    <div className="text-2xl font-semibold">
                        {t('dataFlow.ReviewComplete')}
                    </div>
                </div>
                <div className="mt-6 mb-24">
                    <Form.Item
                        label={t('dataFlow.ReviewBy')}
                        name="reviewBy"
                        className="text-[#65707A]"
                    >
                        {isReviewBy2 ? (
                            <div className="space-y-2">
                                {reviewBy ? (
                                    <div className="flex items-center space-x-2">
                                        <span>{reviewBy}</span>
                                        {dataFlowInfo?.reviewDate && (
                                            <div className="reviewed">
                                                {t('reviewed')}{' '}
                                                {ConvertDate(
                                                    dataFlowInfo?.reviewDate
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    '-'
                                )}
                                {reviewBy2 && (
                                    <div className="flex items-center space-x-2">
                                        <span>{reviewBy2}</span>
                                        {dataFlowInfo?.reviewDate2 ? (
                                            <div className="reviewed">
                                                {t('reviewed')}{' '}
                                                {ConvertDate(
                                                    dataFlowInfo?.reviewDate2
                                                )}
                                            </div>
                                        ) : (
                                            <div className="waitreviewed">
                                                {t('Waiting for Review')}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <span>
                                {username} ({review?.departmentCode})
                            </span>
                        )}
                    </Form.Item>
                    {!isReviewBy2 && (
                        <div className="flex justify-between items-center">
                            <label className="font-semibold">
                                {t('Forward to the next reviewer')}
                            </label>
                            <Form.Item
                                name="isSecondReviewRequire"
                                valuePropName="checked"
                                className="mb-0"
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                    )}
                    {isSecondReviewRequire && (
                        <ul className="text-[#1890FF]">
                            <li>
                                {t(
                                    'Next reviewer This is the last step in checking Data Flow'
                                )}
                            </li>
                            <li>{t('After pressing')}</li>
                        </ul>
                    )}
                    <Divider />
                    {isSecondReviewRequire && (
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                            label={t('Select the name of the next reviewer')}
                            name="reviewBy2"
                        >
                            <Select
                                size="large"
                                placeholder={t(
                                    'Select the name of the next reviewer'
                                )}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                {oraganize
                                    ?.filter((admin) => admin?.userId !== id)
                                    ?.map((oraganize) => (
                                        <Select.Option
                                            key={oraganize?.userId}
                                            value={oraganize?.userId}
                                        >
                                            {oraganize?.fullName} (
                                            {oraganize?.departmentCode})
                                        </Select.Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    )}
                    <Form.Item
                        label={t('dataFlow.LastReviewDate')}
                        name="lastReviewDate"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'dataFlow.PleaseInputLastReviewDate'
                                ),
                            },
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            showTime
                            format="DD/MM/YYYY HH:mm"
                            placeholder={t(
                                'dataFlow.PleaseSelectLastReviewDate'
                            )}
                            onChange={(value) => {
                                setStartDate(value);
                            }}
                            disabledDate={disabledDateStart}
                        />
                    </Form.Item>
                    <Form.Item
                        label={t('dataFlow.NextReviewDue')}
                        name="nextReviewDue"
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            showTime
                            disabledDate={disabledDate}
                            onChange={(value) => {
                                setEndDate(value);
                            }}
                            format="DD/MM/YYYY HH:mm"
                            placeholder={t(
                                'dataFlow.PleaseSelectNextReviewDue'
                            )}
                        />
                    </Form.Item>
                    <Form.Item label={t('Additional comments')} name="comment">
                        <Input.TextArea maxLength={500} showCount rows={4} />
                    </Form.Item>
                </div>
                <div className="flex justify-center items-center space-x-4">
                    <Button
                        type="primary"
                        onClick={handelClose}
                        size="large"
                        ghost
                    >
                        {t('common.Cancel')}
                    </Button>

                    <Button
                        loading={loading}
                        size="large"
                        htmlType="submit"
                        type="primary"
                    >
                        {t('common.Submit')}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};
export default ModalReviewed;
